import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-start",
  "use": "icon-icon-start-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-start\"><defs><style></style></defs><path d=\"M305.032 195.566c0-15.954 10.718-21.557 23.818-12.451L785.31 500.38c13.1 9.106 13.1 24.006 0 33.111L328.85 850.755c-13.1 9.106-23.818 3.503-23.818-12.451V195.566z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol